{
    "columns": [
      {
        "header_id": "timeSheetLineDetailId",
        "header_label": "Timesheet ID",
        "jsonpath": "timeSheetLineDetailId",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "providerPplId",
        "header_label": "PA PPL ID",
        "jsonpath": "providerPplId",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "providerName",
        "header_label": "PA Name",
        "jsonpath": "providerName",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "serviceFromDate",
        "header_label": "From Date",
        "jsonpath": "serviceFromDate",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      
      {
        "header_id": "serviceToDate",
        "header_label": "To Date",
        "jsonpath": "serviceToDate",
        "isDisplayedAtHeader": "n",
        "isSearchable": "n"
      },
      {
        "header_id": "usedUnits",
        "header_label": "Utilized Units",
        "jsonpath": "usedUnits",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      }
    ],
    "buttons": [],
    "apiDetails": "authTimesheetsList.json",
    "pageName": "addAuthorizationsList",
    "orderByColumn": ["timeSheetLineDetailId"],
    "orderBy": ["desc"]
  }
  